import type { User } from "@/lib/api-types";

// Shared option lists for the admin user filters + role/status controls.
// Kept in a plain .ts module (no components) so editing the badge components
// in adminBadges.tsx doesn't trip react-refresh's only-export-components rule.

export const USER_STATUSES: User["user_status"][] = [
  "ACTIVE",
  "INACTIVE",
  "SUSPENDED",
  "DELETED",
];

export const USER_ROLES: User["role_id"][] = [
  "SUPER_ADMIN",
  "STUDENT",
  "ORG_OWNER",
  "ORG_USER",
];
